export const mockPrograms = [
  {
    id: '1',
    title: 'Culte dominical',
    day: 'Dimanche',
    startTime: '10:00',
    endTime: '12:00',
    location: 'Sanctuaire principal',
    description: 'Culte de célébration avec louange, enseignement et prière.',
    category: 'culte',
  },
  {
    id: '2',
    title: 'Étude biblique',
    day: 'Mercredi',
    startTime: '19:00',
    endTime: '20:30',
    location: 'Salle de conférence',
    description: 'Étude approfondie des Écritures avec discussion et partage.',
    category: 'etude',
  },
  {
    id: '3',
    title: 'Prière intercession',
    day: 'Vendredi',
    startTime: '18:00',
    endTime: '19:30',
    location: 'Chapelle',
    description: 'Moment de prière et d intercession pour l église et le monde.',
    category: 'priere',
  },
  {
    id: '4',
    title: 'Réunion chorale',
    day: 'Samedi',
    startTime: '14:00',
    endTime: '16:00',
    location: 'Salle de musique',
    description: 'Répétition de la chorale et préparation des chants.',
    category: 'chorale',
  },
  {
    id: '5',
    title: 'Évangélisation',
    day: 'Samedi',
    startTime: '10:00',
    endTime: '12:00',
    location: 'Centre-ville',
    description: 'Sortie évangélique pour partager la foi dans la communauté.',
    category: 'evangelisation',
  },
];

export const mockEvents = [
  {
    id: '1',
    title: 'Conférence de jeunesse',
    image: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=800&h=500&fit=crop',
    date: '2024-12-15',
    startTime: '09:00',
    endTime: '17:00',
    location: 'Salle des fêtes',
    description: 'Une journée spéciale pour les jeunes avec ateliers, témoignages et concert.',
    program: '09:00 - Accueil et petit-déjeuner\\n10:00 - Session de louange\\n11:00 - Témoignage invité\\n12:30 - Déjeuner\\n14:00 - Ateliers thématiques\\n16:00 - Concert de jeunesse\\n17:00 - Clôture',
  },
  {
    id: '2',
    title: 'Nuit de prière',
    image: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=800&h=500&fit=crop',
    date: '2024-12-20',
    startTime: '20:00',
    endTime: '06:00',
    location: 'Sanctuaire',
    description: 'Nuit de veille et d adoration pour la fin de l année.',
    program: '20:00 - Début de l adoration\\n22:00 - Session de prière\\n00:00 - Moment de silence\\n02:00 - Prière de déclaration\\n04:00 - Prière du matin\\n06:00 - Clôture',
  },
  {
    id: '3',
    title: 'Baptême collectif',
    image: 'https://images.unsplash.com/photo-1548625149-fc4a29cf7092?w=800&h=500&fit=crop',
    date: '2024-12-25',
    startTime: '10:00',
    endTime: '13:00',
    location: 'Piscine municipale',
    description: 'Cérémonie de baptême par immersion pour les nouveaux croyants.',
    program: '10:00 - Accueil des familles\\n10:30 - Enseignement sur le baptême\\n11:30 - Cérémonie de baptême\\n12:30 - Réception',
  },
];

export const mockVideos = [
  {
    id: '1',
    title: 'La foi qui déplace les montagnes',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    description: 'Un message inspirant sur le pouvoir de la foi dans les moments difficiles.',
    category: 'Prédication',
    date: '2024-11-20',
  },
  {
    id: '2',
    title: 'Comment prier efficacement',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    description: 'Enseignement pratique sur la prière et l intimité avec Dieu.',
    category: 'Enseignement',
    date: '2024-11-15',
  },
  {
    id: '3',
    title: 'Concert de louange - Édition spéciale',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    description: 'Moments de louange et d adoration avec la chorale Emmaüs.',
    category: 'Louange',
    date: '2024-11-10',
  },
];

export const mockGalleryFolders = [
  {
    id: '1',
    name: 'Baptême',
    coverImage: 'https://images.unsplash.com/photo-1548625149-fc4a29cf7092?w=600&h=400&fit=crop',
    description: 'Photos des cérémonies de baptême',
    photoCount: 24,
  },
  {
    id: '2',
    name: 'Culte',
    coverImage: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=600&h=400&fit=crop',
    description: 'Moments de culte et d adoration',
    photoCount: 56,
  },
  {
    id: '3',
    name: 'Concert',
    coverImage: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=600&h=400&fit=crop',
    description: 'Photos des concerts et événements musicaux',
    photoCount: 32,
  },
  {
    id: '4',
    name: 'Conférence',
    coverImage: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=600&h=400&fit=crop',
    description: 'Photos des conférences et séminaires',
    photoCount: 41,
  },
  {
    id: '5',
    name: 'Jeunesse',
    coverImage: 'https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?w=600&h=400&fit=crop',
    description: 'Photos des activités de la jeunesse',
    photoCount: 38,
  },
];

export const mockCommunities = [
  {
    id: '1',
    name: 'Jeunesse',
    image: 'https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?w=400&h=300&fit=crop',
    description: 'Groupe des jeunes de 18 à 35 ans pour la croissance spirituelle et le fraternité.',
    leader: 'Marie L.',
    day: 'Samedi',
    time: '15:00 - 17:00',
  },
  {
    id: '2',
    name: 'Femmes',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=300&fit=crop',
    description: 'Communauté des femmes pour le partage, la prière et le soutien mutuel.',
    leader: 'Sarah K.',
    day: 'Mardi',
    time: '19:00 - 21:00',
  },
  {
    id: '3',
    name: 'Hommes',
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=400&h=300&fit=crop',
    description: 'Groupe des hommes pour la prière, l accountability et la croissance.',
    leader: 'Paul M.',
    day: 'Jeudi',
    time: '19:00 - 21:00',
  },
  {
    id: '4',
    name: 'Enfants',
    image: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400&h=300&fit=crop',
    description: 'École du dimanche pour les enfants de 3 à 12 ans.',
    leader: 'Anne D.',
    day: 'Dimanche',
    time: '10:00 - 12:00',
  },
  {
    id: '5',
    name: 'Chorale',
    image: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=400&h=300&fit=crop',
    description: 'Groupe de louange et adoration pour le culte et les événements.',
    leader: 'David S.',
    day: 'Samedi',
    time: '14:00 - 16:00',
  },
  {
    id: '6',
    name: 'Intercession',
    image: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=400&h=300&fit=crop',
    description: 'Équipe de prière intercession pour l église et les missions.',
    leader: 'Ruth B.',
    day: 'Vendredi',
    time: '18:00 - 19:30',
  },
  {
    id: '7',
    name: 'Évangélisation',
    image: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=400&h=300&fit=crop',
    description: 'Équipe dédiée à l évangélisation et au partage de la foi.',
    leader: 'Jean P.',
    day: 'Samedi',
    time: '10:00 - 12:00',
  },
];